class ServicesSection extends HTMLElement {
  constructor() {
    super();

    this.entries = {};

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const { isIntersecting, intersectionRatio, target } = entry;

          this.entries[entry.target.dataset.service] = {
            isIntersecting,
            intersectionRatio,
            target,
          };
        });

        this.updateActiveLink();
      },
      {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      },
    );

    this.services.forEach((service) => observer.observe(service));
  }

  connectedCallback() {}

  disconnectedCallback() {}

  get services() {
    return this.querySelectorAll("[data-service]");
  }

  get serviceLinks() {
    return this.querySelectorAll("[data-service-link]");
  }

  updateActiveLink() {
    const mostVisible = Object.values(this.entries)
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

    const mostVisibleService = mostVisible?.target.dataset.service || null;

    this.serviceLinks.forEach((serviceLink) => {
      serviceLink.classList.toggle(
        "services__left-link--active",
        serviceLink.dataset.serviceLink === mostVisibleService,
      );
    });
  }
}

if (!customElements.get("services-section")) {
  customElements.define("services-section", ServicesSection);
}
